export default "__VITE_ASSET__pXJSuM0t__"